<template>
	<div class="h-full flex justify-center">
		<div class="flex flex-col h-full w-full max-w-xl">
			<div class="grow px-3 sm:px-5 my-3 2xl:my-6">
				<div class="h-full flex flex-col justify-center">
					<offer-request />
					<div class="h-3 grid justify-items-center">
						<div class="max-w-[1600px]">
							<ejs-progressbar v-if="loading" ref="indeterminate" id="successcontainer" type='Linear' isIndeterminate=true value=20></ejs-progressbar>
						</div>
					</div>
						<panel :title="$t('eny.partner_income')" addclass="mt-4">
						<form id="partner-income-form">
							<div class="flex flex-col">
								<div class="flex flex-col items-center">
									<!-- Question partner additional income -->
									<div class="w-full max-w-text e-float-input">
										<p id="main_question" class="w-full text-center">{{$t('eny.question_partner_income')}}</p>
									</div>
									<!-- Has partner income -->
									<validation cssClass="w-full max-w-text pt-2">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_has_partner_income_1" name="cust_has_partner_income" value='1' v-model="request_loc.has_partner_income" />
												<label for="radio_has_partner_income_1"><span>{{$t('eny.yes')}}</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_has_partner_income_0" name="cust_has_partner_income" value='0' v-model="request_loc.has_partner_income" />
												<label for="radio_has_partner_income_0"><span>{{$t('eny.no')}}</span></label>
											</div>
										</div>
									</validation>
								</div>
								<!-- Customer partner data -->
								<div v-show="request_loc.has_partner_income == 1" class="flex flex-col items-center">
									<!-- Customer partner first name -->
									<validation cssClass="w-full max-w-text">
										<ejs-maskedtextbox id="cust_partner_firstname" name="cust_partner_firstname" floatLabelType="Auto" :placeholder="$t('eny.firstname')" v-model:value="request_loc.partner_firstname"></ejs-maskedtextbox>
									</validation>
									<!-- Customer partner last name -->
									<validation cssClass="w-full max-w-text">
										<ejs-maskedtextbox id="cust_partner_lastname" name="cust_partner_lastname" floatLabelType="Auto" :placeholder="$t('eny.lastname')" v-model:value="request_loc.partner_lastname"></ejs-maskedtextbox>
									</validation>
									<!-- Customer partner dob -->
									<validation cssClass="w-full max-w-text">
										<ejs-datepicker :change="this.triggerChangeValidate" @input="this.triggerInputValidate" ref="dob" id='cust_partner_dob' name='cust_partner_dob' floatLabelType="Auto" :placeholder="$t('eny.dob')" v-model:value="request_loc.partner_dob" :format="$t('eny.date_format')" :open='onOpen'></ejs-datepicker>
									</validation>
									<!-- Nationality -->
									<validation cssClass="w-full max-w-text">
										<ejs-dropdown id='cust_partner_nationality' name='cust_partner_nationality' :dataSource='nationalities' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.nationality')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.partner_nationality"></ejs-dropdown>
									</validation>
									<!-- Customer partner phone -->
									<validation cssClass="w-full max-w-text">
										<ejs-maskedtextbox id="cust_partner_phone" name="cust_partner_phone" floatLabelType="Auto" :placeholder="$t('eny.mobphone')" v-model:value="request_loc.partner_phone"></ejs-maskedtextbox>
									</validation>
									<!-- Employment relationship -->
									<validation cssClass="w-full max-w-text">
										<ejs-dropdown id='cust_partner_employment_rel' name='cust_partner_employment_rel' :dataSource='employment_rels' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.employment_rel')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.partner_employment_rel"></ejs-dropdown>
									</validation>
									<!-- Customer partner monthly income -->
									<validation cssClass="w-full max-w-text">
										<div class="flex flex-row">
											<ejs-numerictextbox id="cust_partner_monthly_income" name="cust_partner_monthly_income" format='# ###' floatLabelType="Auto" :showSpinButton="false" :placeholder="$t('eny.monthly_salary')" v-model:value="request_loc.partner_monthly_salary"></ejs-numerictextbox>
											<text-box-extension :label="$t('eny.chf')" />
											</div>
									</validation>
									<!-- Question number of partner monthly salary -->
									<validation cssClass="w-full max-w-text e-float-input">
										<p id="question" class="w-full text-center">{{$t('eny.number_of_monthly_salary')}}</p>
									</validation>
									<!-- Number of partner monthly salary -->
									<validation cssClass="w-full max-w-text pt-2">
										<div class='eny-radio-toolbar w-full'>
											<div class="eny-radio">
												<input type="radio" id="radio_partner_nms_12" name="number_of_partner_monthly_salary" value='12' v-model="request_loc.partner_salary_number" />
												<label for="radio_partner_nms_12"><span>12</span></label>
											</div>
											<div class="eny-radio">
												<input type="radio" id="radio_partner_nms_13" name="number_of_partner_monthly_salary" value='13' v-model="request_loc.partner_salary_number" />
												<label for="radio_partner_nms_13"><span>13</span></label>
											</div>
										</div>
									</validation>
									<!-- Customer partner employer -->
									<validation cssClass="w-full max-w-text">
										<ejs-maskedtextbox id="cust_partner_employer" name="cust_partner_employer" floatLabelType="Auto" :placeholder="$t('eny.employer')" v-model:value="request_loc.partner_employer"></ejs-maskedtextbox>
									</validation>
									<!-- Customer partner employer street nr -->
									<validation cssClass="w-full max-w-text">
										<ejs-maskedtextbox id="cust_partner_employer_street_nr" name="cust_partner_employer_street_nr" floatLabelType="Auto" :placeholder="$t('eny.street_nr')" v-model:value="request_loc.partner_employer_street_nr"></ejs-maskedtextbox>
									</validation>
									<!-- Customer partner employer zip/city -->
									<div class="w-full max-w-text flex gap-2">
										<div class="w-1/3">
											<validation><ejs-maskedtextbox :change="handleChange" id="cust_partner_employer_zip" name="cust_partner_employer_zip" floatLabelType="Auto" :placeholder="$t('eny.zip')" v-model:value="request_loc.partner_employer_zip"></ejs-maskedtextbox></validation>
										</div>
										<div class="w-2/3" v-if="this.multipleCity === true">
											<ejs-combobox id='cust_partner_employer_city' name='cust_partner_employer_city' :dataSource='this.cities' :fields='cityFields' floatLabelType="Auto" :placeholder="$t('eny.city')" :showClearButton="false" :allowCustom="false" v-model:value="request_loc.partner_employer_city"></ejs-combobox>
										</div>
										<div class="w-2/3" v-else>
											<ejs-maskedtextbox id="cust_partner_employer_city" name="cust_partner_employer_city" floatLabelType="Auto" :placeholder="$t('eny.city')" v-model:value="request_loc.partner_employer_city"></ejs-maskedtextbox>
										</div>
									</div>
									<!-- Customer partner employer rel since -->
									<validation cssClass="w-full max-w-text">
										<ejs-datepicker id='cust_partner_employer_rel_since' name='cust_partner_employer_rel_since' floatLabelType="Auto" :placeholder="$t('eny.question_since_when')" v-model:value="request_loc.partner_employer_rel_since" :format="$t('eny.date_format')" :open='onOpen'></ejs-datepicker>
									</validation>
								</div>
							</div>
						</form>
					</panel>
					<!-- Buttons -->
					<div v-if="allow_navigation" class="w-full px-10 md:px-20 py-3 2xl:pt-6 flex flex-row justify-center gap-2 sm:gap-6">
						<email-button />
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="prevStep">{{$t('eny.back')}}</button>
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="nextStep">{{$t('eny.forward')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {mapGetters} from 'vuex';
import axios from "axios";
import {FormValidator, MaskedTextBoxComponent, NumericTextBoxComponent} from '@syncfusion/ej2-vue-inputs';
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";
import {ComboBoxComponent, DropDownListComponent} from "@syncfusion/ej2-vue-dropdowns";
import {ProgressBarComponent} from "@syncfusion/ej2-vue-progressbar";
import Panel from "../../Base/Panel.vue";
import Validation from "../../Base/Validation.vue";
import OfferRequest from "./Request.vue";
import TextBoxExtension from "../../Helper/TextBoxExtension.vue";
import SendEmailButton from "../../Base/SendEmailButton.vue";
import useNotification from "../../hooks/useNotification";
import useUtils from '../../hooks/useUtils';

export default {
	name: "PartnerIncome",
	components: {
		"ejs-maskedtextbox": MaskedTextBoxComponent,
		"ejs-datepicker": DatePickerComponent,
		'ejs-numerictextbox': NumericTextBoxComponent,
		'ejs-progressbar': ProgressBarComponent,
		'ejs-combobox': ComboBoxComponent,
		"ejs-dropdown": DropDownListComponent,
		'panel': Panel,
		'validation': Validation,
		'offer-request': OfferRequest,
		'text-box-extension': TextBoxExtension,
		'email-button': SendEmailButton,
	},
	setup() {
		const { showNotification, hideNotification } = useNotification();
		const { sleep, sortList, timeZoneOffsetOnInit, timeZoneOffsetOnSave, compareDates, isFormattedDateValid } = useUtils();
		return {
			showNotification,
			hideNotification,
			sleep,
			sortList,
			timeZoneOffsetOnInit,
			timeZoneOffsetOnSave,
			compareDates,
			isFormattedDateValid
		}
	},
	data() {
		return {
			// data variables
			request_loc: {},
			partnerIncomeFormFormObject: {},
			cityFields : { text: 'City', value: 'City' },
			fields : { text: 'label', value: 'value' },
			zipCodes:{},
			multipleCity:false,
			cities:{},
			nationalities: this.sortList(JSON.parse(this.$t('country.names')), 'value', 'label', null, JSON.parse(this.$t('country.priorityCountries'))),
			employment_rels: JSON.parse(this.$t('eny.employment_rels'))
		};
	},
	mounted() {
		this.request_loc = this.request;
		const partnerIncomeFormOptions = {
			rules: {
				cust_has_partner_income: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.partner_income')})]},
				cust_partner_firstname: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.firstname')})]},
				cust_partner_lastname: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.lastname')})]},
				cust_partner_dob: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.dob')})],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')]
				},
				cust_partner_nationality: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.nationality')})]},
				cust_partner_phone: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.phonenr')})],
					regex: ["^(\\+41|0)(7[5-9])\\d{7}$", this.$t('eny.phone_not_valid_msg')],
				},
				cust_partner_monthly_income: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.monthly_salary')})]},
				number_of_partner_monthly_salary: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.number_of_monthly_salary')})]},
				cust_partner_employer: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.employer')})]},
				cust_partner_employer_street_nr: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.street_nr')})]},
				cust_partner_employer_zip: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.zip')})],
					number: [true, this.$t('eny.field_onlynumber_error_msg')]
				},
				cust_partner_employer_city: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.city')})]},
				cust_partner_employment_rel: {required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.employment_rel')})]},
				cust_partner_employer_rel_since: {
					required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.date')})],
					custom: [this.isValidDate, this.$t('eny.date_not_valid_msg')],
					min: [this.isAfterPartnerDob, this.$t('eny.date_les_then_date', { date1: this.$t('eny.question_since_when'), date2: this.$t('eny.dob') })]
				},
			},
			customPlacement: this.showValidationError,
		};
		this.request_loc.partner_dob = this.timeZoneOffsetOnInit(this.request_loc.partner_dob)
		this.request_loc.partner_employer_rel_since = this.timeZoneOffsetOnInit(this.request_loc.partner_employer_rel_since)
		this.partnerIncomeFormFormObject = new FormValidator("#partner-income-form", partnerIncomeFormOptions);
		this.getZipMap();
		this.$store.dispatch('customer/update_offer_step', 2);
	},
	computed: {
		...mapGetters('customer', ['request', 'add_incomes', 'success', 'message', 'loading']),
		allow_navigation: function () {
			return this.request.id;
		},
	},
	methods: {
		triggerInputValidate(e) {
			this.partnerIncomeFormFormObject.validate(e.target.name)
		},
		triggerChangeValidate(e){
			this.partnerIncomeFormFormObject.validate(e.element.name);
		},
		getZipMap(){
			axios.get('/customer/getZipMap')
				.then((response) => {
					this.zipCodes = response.data;
				})
		},
		handleChange(e){
			if (e.value.length === 4) {
				if (this.zipCodes[e.value]) {
					if (this.zipCodes[e.value].length!==undefined){
						this.multipleCity = true;
						this.cities = this.zipCodes[e.value];
						this.request_loc.partner_employer_city = this.cities[0].City;
					}
					else {
						this.multipleCity = false;
						this.request_loc.partner_employer_city = this.zipCodes[e.value].City;
					}
				}
			} else {
				this.multipleCity = false;
				this.request_loc.partner_employer_city = "";
			}
		},
		prevStep: function() {
			this.$router.push('/offer/customer_income');
		},
		nextStep: function() {
			if (this.validate()) {
				const requestCopy  = { ...this.request_loc };
				requestCopy.partner_dob = this.timeZoneOffsetOnSave(this.request_loc.partner_dob)
				requestCopy.partner_employer_rel_since = this.timeZoneOffsetOnSave(this.request_loc.partner_employer_rel_since)
				this.$store.dispatch('customer/store_partner_income', {request: requestCopy});
				this.$router.push('/offer/customer_expenses');
			}
		},
		validate: function() {
			const fieldsToCheck = ['cust_has_partner_income'];
			if (this.request_loc.has_partner_income == 1) {
				fieldsToCheck.push(
					'cust_partner_firstname', 'cust_partner_lastname', 'cust_partner_dob', 'cust_partner_nationality', 'cust_partner_phone', 'cust_partner_employment_rel', 'cust_partner_monthly_income',
					'number_of_partner_monthly_salary', 'cust_partner_employer', 'cust_partner_employer_street_nr', 'cust_partner_employer_zip', 'cust_partner_employer_city', 'cust_partner_employer_rel_since'
				);
			}
			let ok = true;
			fieldsToCheck.forEach(item => ok &= this.partnerIncomeFormFormObject.validate(item))
			return ok;
		},
		onOpen: function(e) {
			this.sleep(10).then(function() {
				e.popup.offsetX = e.popup.relateTo.clientWidth - e.popup.properties.content.clientWidth;
			});
		},
		showValidationError: function(element, errorElement) {
			element.closest('.validation-group')?.querySelector('.error-element').appendChild(errorElement);
		},
		isValidDate: function(input) {
			return this.isFormattedDateValid(input.value, this.$t('eny.moment_date_format'));
		},
		isAfterPartnerDob: function(input) {
			return this.compareDates(input.value, this.request_loc.partner_dob, this.$t('eny.moment_date_format')) === 1;
		}
	},
	watch: {
		message(value, oldValue) {
			if (value !== '') {
				this.showNotification(value, this.success ? 'info ': 'error', 5);
			}
		},
	}
}
</script>
<style>
</style>
